import styled, { css } from 'styled-components';
import { IconContainer } from '../../../../icon';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
const SEARCH_BUTTON_HEIGHT = 48;
const SEARCH_BUTTON_MAX_WIDTH = 300;
const SEARCH_ICON_SIZE = 20;
export const navigationActionToggleSearchContainerStyles = ({ theme, $standalone, }) => css `
	display: flex;
	align-items: stretch;
	width: 100%;
	margin: 0 ${pxToRem(theme.spacing['100'])} 0 ${pxToRem(theme.spacing['200'])};

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.md)}) {
		margin: ${pxToRem(theme.spacing['300'])} ${pxToRem(theme.spacing['400'])};
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		margin: ${pxToRem(theme.spacing['300'])} ${pxToRem(theme.spacing['100'])}
			${pxToRem(theme.spacing['300'])} ${pxToRem(theme.spacing['300'])};
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.xxl)}) {
		max-width: ${pxToRem(SEARCH_BUTTON_MAX_WIDTH)};
	}

	${$standalone &&
    css `
		&& {
			margin: 0;
		}

		@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
			display: none;
		}
	`}
`;
export const NavigationActionToggleSearchContainer = styled.div `
	${navigationActionToggleSearchContainerStyles}
`;
export const navigationActionToggleSearchButtonContainerStyles = ({ theme, $navigationIsOpen, $loginMenuIsOpen, $standalone, }) => css `
	appearance: none;
	display: ${(!$standalone && $navigationIsOpen) || (!$standalone && $loginMenuIsOpen)
    ? 'none'
    : 'flex'};
	align-items: center;
	gap: ${pxToRem(theme.spacing['200'])};
	height: ${pxToRem(SEARCH_BUTTON_HEIGHT)};
	width: 100%;
	padding: 0 ${pxToRem(theme.spacing['200'])};
	border-radius: ${theme.borderRadius.m}px;
	border: ${theme.borderWidth[2]}px solid ${theme.colors.light.borderNavigationSearchField};
	background-color: ${theme.colors.extralight.bgFormField};
	cursor: pointer;

	${$standalone &&
    css `
		flex: 1;
		margin: 0;
	`}

	&,
	* {
		color: ${theme.colors.informative.textFormField};
	}

	&:hover,
	&:focus {
		color: ${theme.colors.informative.textFormField};
		background-color: ${theme.colors.light.bgNavigationSearchFieldHover};
		border-color: ${theme.colors.light.borderNavigationSearchFieldHover};
	}

	&:hover {
		background-color: ${theme.colors.buttons.bgButtonTertiaryHover};
	}

	&:active {
		background-color: ${theme.colors.buttons.bgButtonTertiaryActive};
	}

	&:focus-visible {
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		outline-offset: ${theme.borderWidth.m}px;
	}

	${IconContainer} {
		color: ${theme.colors.highlight.iconInteractive};
		width: ${pxToRem(SEARCH_ICON_SIZE)};
		height: ${pxToRem(SEARCH_ICON_SIZE)};
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		display: flex;
	}
`;
export const NavigationActionToggleSearchButtonContainer = styled.button `
	${navigationActionToggleSearchButtonContainerStyles}
`;
